import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["collapseIcon", "expandIcon", "drawerNavigation", "collapseExpandButton"];

  connect() {
    this.drawerNavigationTarget.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
    this.drawerNavigationTarget.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
  }

  handleMouseEnter() {
    this.collapseExpandButtonTarget.style.opacity = '1';
  }

  handleMouseLeave() {
    if (this.collapseIconTarget.style.display === 'none') {
      this.collapseExpandButtonTarget.style.opacity = '0';
    }
  }

  toggleSidebar() {
    const mainElement = document.getElementById('main-element');
    if (mainElement) {
      mainElement.classList.toggle('md:ml-64');
    }

    this.drawerNavigationTarget.classList.toggle('md:-translate-x-full');
    this.drawerNavigationTarget.classList.toggle('md:translate-x-0');
    this.collapseIconTarget.style.display = this.collapseIconTarget.style.display === 'none' ? 'block' : 'none';
    this.expandIconTarget.style.display = this.expandIconTarget.style.display === 'none' ? 'block' : 'none';
  }
}
